export default {
    section: 'Terms',
    name: 'offer-letter-terms',
    items: [
        {
            type: 'inline',
            text: 'Cash Down Payment',
            items: [
                {
                    type: 'text-field',
                    name: 'offer-letter-terms-down-payment-dollars',
                    width: 3,
                    props: {
                        format: 'dollars'
                    }
                },
                {
                    type: 'text-field',
                    name: 'offer-letter-terms-down-payment-percent',
                    width: 3,
                    props: {
                        format: 'percent'
                    }
                }
            ]
        },
        {
            type: 'radio-list',
            text: 'Escrow/Ear-Marked',
            name: 'offer-letter-terms-escrow',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'inline',
                    text: '% Released Immediately',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-terms-released-immediately-dollars',
                            width: 3,
                            props: {
                                format: 'dollars'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'offer-letter-terms-released-immediately-percent',
                            width: 3,
                            props: {
                                format: 'percent'
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-escrow',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: '% Held Back',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-terms-held-back-dollars',
                            width: 3,
                            props: {
                                format: 'dollars'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'offer-letter-terms-held-back-percent',
                            width: 3,
                            props: {
                                format: 'percent'
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-escrow',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'datepicker',
                    text: 'Adjustment Date',
                    name: 'offer-letter-terms-adjustment-date',
                    width: 3,
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-escrow',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Notes',
                    name: 'offer-letter-terms-adjustment-notes',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-escrow',
                                value: 'yes'
                            }
                        ]
                    }
                },
            ]
        },
        {
            type: 'radio-list',
            text: 'Promissory/Seller Note',
            name: 'offer-letter-terms-promissory',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'inline',
                    text: 'Remaining Balance',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-terms-remaining-balance-dollars',
                            width: 3,
                            props: {
                                format: 'dollars'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'offer-letter-terms-remaining-balance-percent',
                            width: 3,
                            props: {
                                format: 'percent'
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-promissory',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Financing Period',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-terms-financing-period-length',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-terms-financing-period-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-promissory',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'selectlist',
                    text: 'Payment Frequency',
                    name: 'offer-letter-terms-payment-frequency',
                    width: 3,
                    props: {
                        items: [
                            {
                                text: 'Weekly',
                                value: 'weekly'
                            },
                            {
                                text: 'Monthly',
                                value: 'monthly'
                            },
                            {
                                text: 'Semi-Monthly',
                                value: 'semi-monthly'
                            },
                            {
                                text: 'Tri-Annually',
                                value: 'tri-annually'
                            },
                            {
                                text: 'Quarterly',
                                value: 'quarterly'
                            },
                            {
                                text: 'Bi-Annually',
                                value: 'bi-annually'
                            },
                            {
                                text: 'Annually',
                                value: 'annually'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-promissory',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    text: 'Annual Interest Rate',
                    name: 'offer-letter-terms-interest-rate',
                    width: 3,
                    props: {
                        label: 'Annual Interest Rate',
                        format: 'percent'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-promissory',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'radio-list',
                    text: 'Prepayments',
                    name: 'offer-letter-terms-prepayments',
                    props: {
                        row: true,
                        items: [
                            // TODO: Verify if this is a yes/no question, also in earnout
                            {
                                text: 'Yes',
                                value: 'yes'
                            },
                            {
                                text: 'No',
                                value: 'no'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-promissory',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Notes',
                    name: 'offer-letter-terms-promissory-notes',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-promissory',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'radio-list',
            text: 'Earn-out',
            name: 'offer-letter-terms-earnout',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'selectlist',
                    text: 'Type',
                    name: 'offer-letter-terms-earnout-type',
                    width: 3,
                    props: {
                        items: [
                            // TODO: Define Earn Out Types
                            {
                                text: 'swap-earnout-types',
                                value: 'swap-earnout-types'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-earnout',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Annual Gross Revenue of Acquired Assets',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-terms-earnout-gross-dollars',
                            width: 3,
                            props: {
                                label: 'Gross Revenue',
                                format: 'dollars'
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'offer-letter-terms-earnout-gross-percent',
                            width: 3,
                            props: {
                                label: '% of Revenue',
                                format: 'percent'
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-earnout',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Financing Period',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-terms-earnout-financing-period-length',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-terms-earnout-financing-period-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-earnout',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'selectlist',
                    text: 'Payment Frequency',
                    name: 'offer-letter-terms-earnout-payment-frequency',
                    width: 3,
                    props: {
                        items: [
                            {
                                text: 'Weekly',
                                value: 'weekly'
                            },
                            {
                                text: 'Monthly',
                                value: 'monthly'
                            },
                            {
                                text: 'Semi-Monthly',
                                value: 'semi-monthly'
                            },
                            {
                                text: 'Tri-Annually',
                                value: 'tri-annually'
                            },
                            {
                                text: 'Quarterly',
                                value: 'quarterly'
                            },
                            {
                                text: 'Bi-Annually',
                                value: 'bi-annually'
                            },
                            {
                                text: 'Annually',
                                value: 'annually'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-earnout',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    text: 'Annual Interest Rate',
                    name: 'offer-letter-terms-earnout-interest-rate',
                    width: 3,
                    props: {
                        label: 'Annual Interest Rate',
                        format: 'percent'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-earnout',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'radio-list',
                    text: 'Prepayments',
                    name: 'offer-letter-terms-earnout-prepayments',
                    props: {
                        row: true,
                        items: [
                            {
                                text: 'Yes',
                                value: 'yes'
                            },
                            {
                                text: 'No',
                                value: 'no'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-earnout',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Notes',
                    name: 'offer-letter-terms-earnout-notes',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-terms-earnout',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'text-field',
            text: 'Retention Bonus',
            name: 'offer-letter-terms-retention',
            width: 3,
            props: {
                label: 'Retention Bonus',
                format: 'dollars'
            },
            subItems: [
                {
                    type: 'inline',
                    text: 'Terms',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-terms-retention-length',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-terms-retention-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    type: 'textarea',
                    text: 'Notes',
                    name: 'offer-letter-terms-retention-notes',
                    props: {}
                }
            ]
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/offer-letter/valuation-data/terms.js